import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-row-edit",
  "use": "svgIcon-row-edit-usage",
  "viewBox": "0 0 399.14 399.14",
  "content": "<symbol viewBox=\"0 0 399.14 399.14\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-row-edit\"><circle cx=\"108.75\" cy=\"72.98\" r=\"60\" fill=\"currentColor\" /><path d=\"M192.389 202.238c-19.946-23.984-50.006-39.258-83.639-39.258C48.689 162.98 0 211.669 0 271.73h122.897zM300.376 136.676l38.661-38.661 60.104 60.104-38.661 38.661zM110.998 386.16l68.464-19.986-48.478-48.477zM146.381 290.67l132.782-132.782 60.104 60.104-132.782 132.782z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol